import React, { useState } from "react";
import Header from "../components/Header";

export default function BookingSlot() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");

  const [selectedPackage, setSelectedPackage] = useState("");
  const [customAmount, setCustomAmount] = useState("");
  const [showCustomInput, setShowCustomInput] = useState(false);

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const packages = [50, 100, 150, 200];

  // ---------------- VALIDATION ----------------
  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) return "Email is required";
    if (!emailRegex.test(value)) return "Invalid email";
    return "";
  };

  const validatePhone = (value) => {
    const phoneNumbersOnly = value.replace(/\D/g, "");
    if (!value) return "Phone is required";
    if (phoneNumbersOnly.length < 10) return "Phone must be at least 10 digits";
    return "";
  };

  const getFinalAmount = () => {
    if (selectedPackage) return Number(selectedPackage);
    if (customAmount) return Number(customAmount) || 0;
    return 0;
  };

  const isFormValid = () => {
    const amount = getFinalAmount();
    return (
      name.trim() &&
      email.trim() &&
      phone.trim() &&
      date.trim() &&
      amount >= 50 &&
      !errors.name &&
      !errors.email &&
      !errors.phone &&
      !errors.date &&
      !errors.amount
    );
  };

  // ---------------- SUBMIT ----------------
  const handleContinue = async () => {
    const amount = getFinalAmount();

    const newErrors = {
      name: !name.trim() ? "Name is required" : "",
      email: validateEmail(email.trim()),
      phone: validatePhone(phone.trim()),
      date: !date.trim() ? "Date is required" : "",
      amount:
        !selectedPackage && !customAmount
          ? "Select a package or enter an amount"
          : customAmount && Number(customAmount) < 50
          ? "Minimum amount is 50 GBP"
          : "",
    };

    setErrors(newErrors);

    if (Object.values(newErrors).some((e) => e)) {
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch(
        "https://andromeda-sim.com/sha/create-checkout-session.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: name.trim(),
            email: email.trim(),
            phone: phone.trim(),
            date: date.trim(),
            amount: amount,
          }),
        }
      );

      const session = await response.json();

      if (session.success && session.url) {
        window.location.href = session.url;
      } else {
        setErrors((prev) => ({
          ...prev,
          amount: session.error || "Payment error",
        }));
      }
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        amount: "Server error. Try again.",
      }));
    } finally {
      setSubmitting(false);
    }
  };

  // ---------------- UI ----------------
  return (
    <>
      <Header />
      <div className="booking-page">
        <div className="booking-card">
          <h1>Book Your Training Session</h1>
<div className="flex-div">
          {/* Name */}
          <div className="field flex-item">
            <label>Name</label>
            <input
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setErrors((prev) => ({ ...prev, name: "" }));
              }}
              disabled={submitting}
            />
            {errors.name && <span className="error">{errors.name}</span>}
          </div>

          {/* Email */}
          <div className="field flex-item">
            <label>Email</label>
            <input
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrors((prev) => ({ ...prev, email: validateEmail(e.target.value) }));
              }}
              disabled={submitting}
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>
</div>

<div className="flex-div">
          {/* Phone */}
          <div className="field flex-item">
            <label>Phone</label>
            <input
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
                setErrors((prev) => ({ ...prev, phone: validatePhone(e.target.value) }));
              }}
              disabled={submitting}
            />
            {errors.phone && <span className="error">{errors.phone}</span>}
          </div>

          {/* Date */}
          <div className="field flex-item">
            <label>Select Date</label>
            <input
              type="date"
              min={new Date().toISOString().split("T")[0]}
              value={date}
              onChange={(e) => {
                setDate(e.target.value);
                setErrors((prev) => ({ ...prev, date: "" }));
              }}
              disabled={submitting}
            />
            {errors.date && <span className="error">{errors.date}</span>}
          </div>
</div>
          {/* Packages */}
          
          <div className="field">
            <label>Select Package</label>
            <div>
            <div className="time-grid ">
              {packages.map((pkg) => (
                <button
                  key={pkg}
                  className={`time-slot ${selectedPackage === pkg ? "active" : ""}`}
                  onClick={() => {
                    setSelectedPackage(pkg);
                    setCustomAmount("");
                    setShowCustomInput(false);
                    setErrors((prev) => ({ ...prev, amount: "" }));
                  }}
                  disabled={submitting}
                >
                  £{pkg}
                </button>
              ))}</div>
              
              {/* Custom Amount Button */}
              <div className="time-grid-special">
              <button
                className={`time-slot ${showCustomInput ? "active" : ""}`}
                onClick={() => {
                  setShowCustomInput(true);
                  setSelectedPackage("");
                  setErrors((prev) => ({ ...prev, amount: "" }));
                }}
                disabled={submitting}
              >
                Enter Custom Price
              </button>
            </div>
            </div>
          </div>

          {/* Custom Amount Input - Only shown when button clicked */}
          {showCustomInput && (
            <div className="field">
              <label>Enter Custom Amount (Min £50)</label>
              <input
                type="number"
                min="50"
                placeholder="Enter amount"
                value={customAmount}
                onChange={(e) => {
                  setCustomAmount(e.target.value);
                  setErrors((prev) => ({ ...prev, amount: "" }));
                }}
                disabled={submitting}
                autoFocus
              />
              {errors.amount && <span className="error">{errors.amount}</span>}
            </div>
          )}

          {/* Submit Button */}
          <button
            className="continue-btn"
            disabled={!isFormValid() || submitting}
            onClick={handleContinue}
          >
            {submitting ? "Processing..." : "Continue to Payment"}
          </button>
        </div>
      </div>
    </>
  );
}